import { Container } from '@dansk-metal/ui';
import { formatDate } from '@dansk-metal/utils/date';

import DefinitionList from '@web/components/definition-list/definition-list';

import { CompanyMemberDto, useGetDepartmentById } from '@web/services/crm-api/rest';

import { getMembershipStatus } from '@web/utils/get-membership-type-from-flags';
import { removeFirstNumbersString } from '@web/utils/remove-first-string-number';

import styles from './member-drawer-content.module.scss';

interface MemberDrawerContentProps {
	member: CompanyMemberDto;
}

export function MemberDrawerContent({ member }: MemberDrawerContentProps) {
	const departmentId = member?.departmentId ? member.departmentId : '';

	const {
		data: department,
	} = useGetDepartmentById(departmentId);



	const unionClubList = member?.unionClubs ? member.unionClubs.map((club) => club.name).filter((name): name is string => !!name) : [];

	const data = [
		{ key: 'Telefon', value: member?.phoneNumber ? member.phoneNumber : '-' },
		{ key: 'Email', value: member?.email ? member.email : '-' },
		{ key: 'Fødselsdato', value: member?.birthdate ? formatDate(new Date(member.birthdate), '22. feb 2022') : '-' },
		{ key: 'Stilling', value: member?.positionName ? removeFirstNumbersString(member.positionName) : '-' },
		{ key: 'Ansættelsesdato', value: member?.employment?.startDate ? formatDate(member.employment.startDate, '22. feb 2022') : '-' },
		{ key: 'Uddannelse', value: member?.educationName ? removeFirstNumbersString(member.educationName) : '-' },
		{ key: 'Medlemsstatus', value: getMembershipStatus(member?.flags) || '-' },
		{ key: 'Lokalafdeling', value: department?.name ? department.name : '-' },
		{ key: 'Klub', value: unionClubList && unionClubList.length > 0 ? unionClubList : '-' },
	];

	return (
		<Container className={styles.container}>
			<h2>{member?.firstName} {member?.lastName}</h2>
			{data && <DefinitionList data={data} className={styles.details} />}
		</Container>
	);
}
